<script>
import {
  defineComponent, computed,
} from '@vue/composition-api';

import DashboardHeader from '../components/DashboardGestor/DashboardHeader.vue';
import DashboardStatistics from '../components/DashboardGestor/DashboardStatistics.vue';
import DashboardCampaigns from '../components/DashboardGestor/DashboardCampaigns.vue';
import DashboardShopsStats from '../components/DashboardGestor/DashboardShopsStats.vue';
import DashboardCampaignResultDialog from '../components/DashboardGestor/DashboardCampaignResultDialog.vue';

import Loader from '../components/Loader.vue';
import { useCampaignsResults } from '../composables/useCampaignsResults';

export default defineComponent({
  components: {
    DashboardHeader,
    DashboardStatistics,
    DashboardCampaigns,
    DashboardShopsStats,
    DashboardCampaignResultDialog,
    Loader,
  },
  setup(props, { root }) {
    const profile = computed(() => root.$store.getters.getProfile);
    const customer = computed(() => root.$store.getters.getCustomer);
    const { loadingResults } = useCampaignsResults();
    return {
      profile,
      customer,
      loadingResults,
    };
  },
});
</script>

<template>
  <v-container
    class="dashboard mt-3 px-4"
    style="min-height: 100vh"
  >
    <div v-if="profile && profile.name && !loadingResults">
      <DashboardHeader />
      <DashboardStatistics v-if="!customer.onlyCatalogue" />
      <DashboardCampaigns v-if="!customer.onlyCatalogue" />
      <DashboardShopsStats v-if="$store.getters.containsCatalogue" />
      <DashboardCampaignResultDialog />
    </div>
    <div
      v-else
      class="ma-2"
    >
      <Loader />
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
.dashboard {
  margin-bottom: 60pt;
}
</style>
